import type { ReactElement, ReactNode } from 'react';
import { TONE_GLYPH, type Tone } from '../domain/labels';

export interface BannerProps {
  readonly tone: Tone;
  readonly title?: string;
  readonly children: ReactNode;
  readonly role?: 'status' | 'alert';
}

/** Inline message block. Danger banners are announced as alerts. */
export function Banner({ tone, title, children, role }: BannerProps): ReactElement {
  const resolvedRole = role ?? (tone === 'danger' ? 'alert' : 'status');
  return (
    <div className={`banner banner--${tone}`} role={resolvedRole}>
      <span className="banner__glyph" aria-hidden="true">
        {TONE_GLYPH[tone]}
      </span>
      <div className="banner__body">
        {title !== undefined && <strong>{title} </strong>}
        {children}
      </div>
    </div>
  );
}
